// 课程详情页公共API存放，例：课程详情；
import ajax from '@/utils/ajax';

const header = '/web';
const headerTwo = '/ref';

export const getActiveInfo = (userProductId) => ajax(`${header}/v1/course-complete/activity/detail-by-user-product?userProductId=${userProductId}`)

export const receiveGive = (data) =>ajax(`${header}/v1/course-complete/activity/receive`, data, 'POST')